import React from "react";
import "./Rodape.scss";
import UtilServices from "@services/UtilServices";
import { useNavigate } from "react-router-dom";
import json from "../../../package.json";
import IconKtech from "@icons/IconKtech";
import IconWhatsApp1 from "@icons/IconWhatsApp1";
import IconInstagram from "@icons/IconInstagram";
import IconLikedin from "@icons/IconLikedin";
import MessageServices from "@services/MessageServices";
import IconKtechRodape from "@icons/IconKtechRodape";

const Rodape = (props) => {
  const navigate = useNavigate();

  const listRope = [
    {
      title: "Endereço",
      iconTitle: <i className="fa-solid fa-location-dot"></i>,
      desc: [
        {
          nome: "Av. Vila Ema, 1899 São Paulo - SP, 03281-000",
          fn: () => {
            openMaps("Av. Vila Ema, 1899 São Paulo");
          },
        },
      ],
    },
    {
      title: "Telefone",
      iconTitle: <i className="fa-solid fa-phone"></i>,
      desc: [
        {
          nome: "+55 (11) 93377-3522",
          fn: () => {
            UtilServices.GetWhatsApp(
              "5511933773522",
              "Olá, Quero saber mais sobre a ktechno",
            );
          },
        },
      ],
    },
    {
      title: "Email",
      iconTitle: <i className="fa-solid fa-envelope"></i>,
      desc: [
        {
          nome: "contato@ktechno.com.br",
          fn: () => {
            openEmail(
              "contato@ktechno.com.br",
              "Quero saber mais sobre ktechno",
              "Olá, estou entrando em contato...",
            );
          },
        },
      ],
    },
    {
      title: "Horário de Atendimento",
      iconTitle: <i className="fa-solid fa-clock"></i>,
      desc: [
        {
          nome: "Segunda a Sexta: 8h ás 18h. Suporte 24/7 para clientes",
        },
      ],
      linha: "none",
    },
  ];

  const openMaps = (address) => {
    const url = `https://www.google.com/maps?q=${encodeURIComponent(address)}`;
    window.open(url, "_blank");
  };
  const openEmail = (email, subject = "", body = "") => {
    const url = `mailto:${email}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = url;
  };
  const openLinkedIn = (usernameOrUrl) => {
    window.open(`https://www.linkedin.com/in/${usernameOrUrl}`, "_blank");
  };
  const openInstagramWeb = (usernameOrUrl) => {
    const url = usernameOrUrl.startsWith("http")
      ? usernameOrUrl
      : `https://instagram.com/${encodeURIComponent(usernameOrUrl)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="rodape" style={{ background: props.backgroundcolor }}>
      <div className="container">
        <div className="row">
          {listRope.map((item, index) => (
            <div className="col-12 col-md-3 text-center text-md-start mt-md-4 mb-4 mb-md-4">
              <div
                className="justify-content-md-between justify-content-center"
                style={{
                  display: "flex",
                  gap: "10px",
                  color: props.color,
                }}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "flex-end",
                      marginBottom: "10px",
                      marginTop: "10px",
                      color: props.color,
                    }}
                  >
                    {item.iconTitle}
                    <p className="titulo">{item.title}</p>
                  </div>
                  {item.desc.map((item2, index) => (
                    <p
                      className="desc"
                      style={{
                        color: props.color2,
                      }}
                      onClick={() => {
                        if (typeof item2?.fn === "function") {
                          item2.fn();
                          return;
                        }
                        navigate(item2.navigate);
                      }}
                      key={index}
                    >
                      {item2.nome}
                    </p>
                  ))}
                </div>
                {item?.linha !== "none" && (
                  <div
                    className="linhas d-none d-md-block"
                    style={{
                      height: "100px",
                      width: "1px",
                      background: props.colorlinha,
                    }}
                  ></div>
                )}
              </div>
            </div>
          ))}
          <div className="logo col-md-12 text-center mt-5">
            <div
              style={{
                marginBottom: "20px",
                display: "flex",
                gap: "20px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconInstagram
                color1={props.color}
                onClick={() => {
                  openInstagramWeb("ktechno");
                }}
              />
              <IconWhatsApp1
                color1={props.color}
                color2={props.backgroundcolor}
                onClick={() => {
                  UtilServices.GetWhatsApp(
                    "5511933773522",
                    "Olá, Quero saber mais sobre a ktechno",
                  );
                }}
                width="25px"
              />
              {/* <IconLikedin
                width="25px"
                color1={props.color}
                onClick={() => {
                  MessageServices.ShowWarning(
                    "Ainda não possuímos LinkedIn, mas estamos trabalhando para disponibilizá-lo em breve.",
                  );
                  
                }}
              /> */}
            </div>
            {props?.iconktech === "white" && (
              <>
                <IconKtech
                  width="60px"
                  onClick={() => {
                    navigate("/");
                  }}
                />
              </>
            )}
            {props?.iconktech === "black" && (
              <>
                <IconKtechRodape
                  onClick={() => {
                    navigate("/");
                  }}
                />
              </>
            )}
          </div>
          <div className="col-6"></div>
          <div className="version row mt-5">
            <div className="col-sm-6 col-12 text-sm-start text-center">
              <p
                style={{
                  color: props.color2,
                }}
              >
                <strong>© 2024 KAITECHNO </strong> Kaique Albano Develop
              </p>
            </div>
            <div
              className="col-sm-6 col-12 mt-sm-0 mt-2 text-sm-end text-center"
              style={{
                color: props.color2,
              }}
            >
              <span>
                <strong>Versão:</strong>{" "}
              </span>
              <span>{json.version} </span>
              <span>
                <strong>Data:</strong>{" "}
              </span>
              <span>{json.databuild}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rodape;
